<div class="kt-portlet container">
	<div class="kt-portlet__head">
		<div class="encabezado mt-3">
			<h1 class="titulo"><i class="fas fa-sim-card"></i>&nbsp;{{titulo}}</h1>
		</div>
	</div>
	<div class="kt-portlet__body">
		<form [formGroup]="simsForm">
			<div class="row">
				<div class="col-md-4 form-group">
					<i class="fas fa-barcode"></i>&nbsp;
					<label for="sim">Sim</label>
					<input formControlName="sim" class="form-control" id="sim" pattern="[0-9]*" [readonly]="idSim"
						required>
					<span class="text-danger"
						*ngIf="(simsForm.get('sim').touched) && simsForm.get('sim').errors?.required">
						Campo requerido
					</span>
				</div>
				<div class="col-md-4 form-group">
					<i class="fas fa-phone-alt"></i>&nbsp;
					<label for="numeroTelefonico">Número Teléfonico</label>
					<input formControlName="numeroTelefonico" class="form-control" id="numeroTelefonico"
						pattern="[0-9]*" required>
					<span class="text-danger"
						*ngIf="(simsForm.get('numeroTelefonico').touched) && simsForm.get('numeroTelefonico').errors?.required">
						Campo requerido
					</span>
				</div>
				<div class="col-md-4 form-group">
					<i class="fas fa-user"></i>&nbsp;
					<label for=" cliente">Cliente</label>
					<select id="cliente" formControlName="idCliente" class="form-control">
						<option *ngFor="let cliente of clientesRegistros" [value]="cliente.id">{{cliente.nombre}}
						</option>
					</select>
					<span class="text-danger"
						*ngIf="(simsForm.get('idCliente').touched) && simsForm.get('idCliente').errors?.required">
						Campo requerido
					</span>
				</div>
				<div class="col-md-4 form-group">
					<i class="fas fa-user"></i>&nbsp;
					<label for="telefonia">Telefonia</label>
					<select id="telefonia" formControlName="idTelefonia" class="form-control">
						<option *ngFor="let telefonia of telefonias" [value]="telefonia.id">{{telefonia.nombre}}
						</option>
					</select>
					<span class="text-danger"
						*ngIf="(simsForm.get('idTelefonia').touched) && simsForm.get('idTelefonia').errors?.required">
						Campo requerido
					</span>
				</div>

				<div class="col-md-4 form-group">
					<i class="fas fa-box-usd"></i>&nbsp;
					<label for="telefonia">Planes Tarifarios</label>
					<select id="telefonia" formControlName="idPlan" class="form-control">
						<option *ngFor="let plan of planesTarifarios" [value]="plan.id">{{plan.nombre}}
						</option>
					</select>
					<span class="text-danger"
						*ngIf="(simsForm.get('idPlan').touched) && simsForm.get('idPlan').errors?.required">
						Campo requerido
					</span>
				</div>
			</div>
		</form>
		<mat-divider></mat-divider>
		<div class="kt-portlet__foot">
			<div class="kt-form__actions kt-form__actions">
				<button id="guardarBoton" mat-raised-button class="mt-3  btn btn-success" (click)="onSubmit()"
					[disabled]="simsForm.invalid || loading"
					[ngClass]="{'kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light': loading}"
					style="margin-right: 15px;"><i class="fa fa-check"></i>&nbsp;Guardar</button>&nbsp;
				<button mat-raised-button (click)="onCancel()"><i class="fas fa-times"></i>&nbsp;Cancelar</button>
			</div>
		</div>
	</div>
</div>
